import { useRef } from 'react'
import { useState } from 'react';
import { HideLoder, ShowLoder } from '../../../JS/Common';
import AlertsComp from '../../../Components/AlertsComp';
import { ValidateFile } from '../../../Components/Validations';
import { log } from '../../../JS/Logger';
import { ApiCmnHeadersPostCall } from '../../../JS/Connector';
import MultiErrorPopup from '../../../Components/MultiErrorPopup';
import { downloadSampleCSV } from '../../../Helpers/ImpExpHelper';

export default function ImportInventory() {
    const InventoryRef = useRef();
    const [loading, setLoading] = useState(false);
    const [NewAlerts, setNewAlerts] = useState("");
    const [FileName, setFileName] = useState({
        error: '',
        document: '',
    });
    const [showErrorPopup, setShowErrorPopup] = useState({
        modal: false,
        btn: false
    });
    const [csvError, setCsvError] = useState("");
    async function ImportCSV(e) {
        setShowErrorPopup({ ...showErrorPopup, modal: false, btn: false });
        setLoading(true)
        e.preventDefault();
        const fileInput = InventoryRef.current;
        const files = fileInput.files[0];
        if (!files) {
            setLoading(false)
            setFileName({ ...FileName, error: "First, import the CSV file.", document: "" });
            return;
        }
        const { isFileValid, validationMsg } = ValidateFile(files, { allowedType: "csv", maxSizeMB: 25 });
        if (!isFileValid) {
            setFileName({ ...FileName, error: validationMsg, document: '' });
            fileInput.value = "";
            return;
        }

        var formdata = new FormData();
        formdata.append("file", files);

        try {
            const response = await ApiCmnHeadersPostCall(`/inventory/master/import`, formdata);
            const result = response;
            setLoading(false);
            if (result == "success") {
                setNewAlerts(<AlertsComp show={true} variant="success" msg={'CSV imported Successfully'} />);
                setTimeout(function () {
                    setNewAlerts(<AlertsComp show={false} />);
                }, 1500);
            } else {
                const responseRs = JSON.parse(result);
                setCsvError(responseRs);
                setShowErrorPopup({ ...showErrorPopup, modal: true, btn: true });
                setFileName({ ...FileName, error: '', document: '' });
                fileInput.value = "";
            }
            fileInput.value = "";
            setFileName({ ...FileName, error: '', document: '' });
        } catch (error) {
            log.error('error', error);
            fileInput.value = "";
            setFileName({ ...FileName, error: '', document: '' });
        }
    }
    function ShowFileName() {
        const fileInput = InventoryRef.current;
        const files = fileInput.files[0];
        if (!files) return;
        const filename = files.name;
        const { isFileValid, validationMsg } = ValidateFile(files, { allowedType: "csv", maxSizeMB: 25 });
        if (!isFileValid) {
            setFileName({ ...FileName, error: validationMsg, document: '' });
            fileInput.value = "";
            return;
        }
        setFileName({ ...FileName, error: "", document: filename });
    }
    return (
        <div>
            {NewAlerts}
            {loading ? <ShowLoder /> : <HideLoder />}
            <div className='row d-flex align-items-center p-1'>
                <span className='GridTitle'>Import Master Inventory</span>
            </div>
            <div className='col-12'>
                <img src='/images/HorizontalLine.svg' className='img-fluid w-100' />
            </div>
            <div className="p-2">
                <p className="text-justify" style={{ fontSize: "13px" }}>
                    To ensure that Master Inventories are entered properly with data accuracy, please download our CSV template file and ensure your columns match the template before you import your master inventory into the system.
                </p>
                <div className="row pt-3 px-3">
                    <label className="pb-4 ps-0" style={{ fontSize: "13px" }}>
                        <a onClick={() => downloadSampleCSV('masterInventory', 'masterinventory')}
                            style={{ color: "#04ADFD", fontWeight: "600" }} className='cursor-pointer'>
                            CLICK HERE
                        </a> {" "}
                        to download the template CSV file for master inventory data. Please use this as a template and prepare your CSV file accordingly. Once your file is ready, use button below to browse file from your computer and click on upload button to import all data into your account.
                    </label>
                    <div className="col-12">
                        <div className='d-flex gap-3 align-items-center'>
                            <form onSubmit={(e) => ImportCSV(e)}>
                                <input type="file" ref={InventoryRef} name="upload_filewithoutstudent" id="UploadFileWithoutStudentId" accept='.csv' onChange={ShowFileName} />
                                <label className='ImportInventoryBtnForimportExport buttonclssMobile1' htmlFor="UploadFileWithoutStudentId"> Import Master Inventory
                                    <img src='/images/ImportInventory.svg' className='img-fluid ps-2' />
                                </label>
                                {FileName.document != '' ?
                                    <input type="submit" value="Upload" className='UploadBtn buttonclssMobile' style={{ backgroundColor: 'var(--primary-color)', color: '#fff' }} />
                                    :
                                    <input type="submit" value="Upload" className='UploadBtn buttonclssMobile' />
                                }
                            </form>
                            {showErrorPopup.btn &&
                                <label title='View CSV Errors' className='text-decoration-underline redText cursor-pointer' onClick={() => setShowErrorPopup({ ...showErrorPopup, modal: true })}>
                                    View Errors
                                </label>
                            }
                        </div>
                        <div className='col-md-12 pe-0'>
                            <div className=" ps-2" style={{ fontWeight: "600", color: 'green' }}>{FileName.document}</div>
                            {FileName.error?.trim() != "" && <label className="redText">{FileName.error}</label>}
                        </div>
                    </div>
                </div>
            </div>
            <MultiErrorPopup isErrorShow={showErrorPopup.modal} setErrorShow={() => setShowErrorPopup({ ...showErrorPopup, modal: !showErrorPopup.modal })} errorMsgs={csvError} />
        </div>
    )
}
